import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

/**
 * De toasts van de server (redirectWithToast: Verwijderd, Wachtwoord
 * gewijzigd, Welkom) in ontwerp v4: dezelfde inktpil als de HeuteToast,
 * met de titel vet en de regel eronder rustig. Alleen de kleren; wanneer
 * en hoe lang ze staan, blijft van sonner.
 */
const EpicToaster = ({ theme, ...props }: ToasterProps) => {
	return (
		<Sonner
			theme={theme}
			className="toaster group"
			// sonner kleurt ook de sluitknop met deze drie: inkt en papier,
			// zodat de knop bij de pil hoort in licht en donker
			style={
				{
					'--normal-bg': 'var(--ink)',
					'--normal-text': 'var(--paper)',
					'--normal-border': 'var(--ink)',
				} as React.CSSProperties
			}
			toastOptions={{
				style: {
					background: 'var(--ink)',
					color: 'var(--paper)',
					border: 0,
					borderRadius: 'var(--r-lg)',
					boxShadow: 'var(--sh-float)',
					fontFamily: 'var(--font-sans)',
					fontSize: 15,
				},
				classNames: {
					title: 'heute-sonner-titel',
					description: 'heute-sonner-tekst',
				},
			}}
			{...props}
		/>
	)
}

export { EpicToaster }
